import currency from 'currency.js'

const USD = (value: string) => currency(value, { symbol: '$', precision: 2 })
export function formatUsdAmount(amount: string) {
  return USD(amount).format()
}
